import { getPublicSettings } from "../../api/endpoints";
import { createQuery } from "./apiHooks";

export const useGetPublicSettings = createQuery(getPublicSettings, {
  queryKey: ["PublicSettings", "Get"],
});
